import { gql } from '@/__generated__';

export const checkoutOrderDocument = gql(/* GraphQL */ `
  query CheckoutOrder($orderId: String!) {
    checkoutOrder(orderId: $orderId) {
      id
      package
      status
      total
      paymentMethodId
      shippingMethodId
      customer {
        id
        name
        email
        avatar
        addresses {
          id
          name
          streetLine
          streetDescription
          city
          postCode
          country
          phone
        }
      }
      address {
        name
        streetLine
        streetDescription
        city
        postCode
        country
        phone
        addressId
      }
      createdAt
      updatedAt
      lines(orderBy: [{ createdAt: asc }]) {
        id
        type
        code
        name
        description
        price
        productVariantId
      }
      live {
        id
        name
        description
        date
      }
      availableShippingMethods {
        id
        name
        description
        fee
      }
      availablePaymentMethods {
        id
        name
        description
        fee
      }
    }
  }
`);

export const sumUpOrderDocument = gql(/* GraphQL */ `
  query SumUpOrder($orderId: String!) {
    sumupOrder(orderId: $orderId) {
      id
      payments {
        id
        amount
        status
        referenceId
      }
    }
  }
`);
